import cn from 'classnames';
import * as React from 'react';
import styles from './Input.module.scss';

export interface IInputProps {
  type: React.HTMLInputTypeAttribute;
  placeholder: string;
  name?: string;
  value?: string;
  icon?: React.ReactNode;
  readOnly?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const Input = ({ icon, className = '', type = 'text', ...rest }: IInputProps): JSX.Element => {
  /* ClassNames */
  const inputClasses: string = cn(styles.input, className);

  return (
    <div className={inputClasses}>
      {icon}
      <input type={type} {...rest} />
    </div>
  );
};

export default Input;
